import React, { useState } from "react";
import { AssignUser } from "app/shared/components/Popups";
import { Button } from "react-bootstrap";
import { Info, Trello, Menu, Plus, User, ShoppingCart } from "react-feather";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import InfoComponent from "app/shared/utility/InfoComponent";
import FormModal from "app/shared/components/FormModal/FormModal";
import FormTypeDropDown from "../../../shared/components/ReportModal/FormTypeDropDown";

const MenuList = ({ menuArr }) => {
  const [modelStatus, setModalStatus] = useState(false);
  const [formModal, setFormModal] = useState(false);

  // const [selectedFormType, setSelectedFormType] = useState("");
  // const [typeList, setTypeList] = useState([
  //   { type_id: 1, form_type: "Data Collection" },
  //   { type_id: 2, form_type: "Audit" },
  //   { type_id: 3, form_type: "Inspection" },
  //   { type_id: 4, form_type: "Checklist" },
  //   { type_id: 5, form_type: "Work Permit" },
  //   { type_id: 8, form_type: "Survey" },
  //   { type_id: 9, form_type: "Mock Drill" },
  //   { type_id: 10, form_type: "Contractor Assessment" },
  //   { type_id: 11, form_type: "Feedback" },
  //   { type_id: 12, form_type: "E-Learning" },
  //   { type_id: 13, form_type: "Assessment" },
  //   { type_id: 14, form_type: "Safety Meeting" },
  //   { type_id: 15, form_type: "Poll" },
  //   { type_id: 16, form_type: "Good Practice" },
  //   { type_id: 17, form_type: "Task Management" },
  // ]);

  const LOCATION = useLocation();

  const handleAssignUserModal = async () => {
    setModalStatus(!modelStatus);
  };

  const _handleFormModal = async () => {
    await setFormModal(!formModal);
  };

  return (
    <div>
      <div className="d-flex-center gap-2">
        {menuArr.dashboard && (
          <Link to="/dashboard">
            <Button
              className={`icon-btn ${
                LOCATION.pathname == "/dashboard" ? `menu-list-active` : ``
              }`}
              title="Dashboard"
            >
              <Trello className="icon-style" />
            </Button>
          </Link>
        )}
        {menuArr.published_form && (
          <Link to="/published-from">
            <Button
              className={`icon-btn ${
                LOCATION.pathname == "/published-from" ? `menu-list-active` : ``
              }`}
              title="Published form"
            >
              <Menu
                className="icon-style "
                style={{ height: "1.8vw", position: "relative", top: "-7px" }}
              />
            </Button>
          </Link>
        )}
        {/* {menuArr.form_type && (
          <FormTypeDropDown
              // title="Do's & Dont's / Training / Policy"
              title="Filter"
              isRequired={false}
              optionList={typeList}
               className="filter"
            />
        )} */}
        {menuArr.created_form && (
          // <Link to="/create-form">
          <Button
            title="Create new form"
            onClick={_handleFormModal}
            style={{ padding: "5px", background: "0", border: "0" }}
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="16" cy="16" r="15.5" fill="white" stroke="#F56620" />
              <path
                d="M22 17H17V22C17 22.55 16.55 23 16 23C15.45 23 15 22.55 15 22V17H10C9.45 17 9 16.55 9 16C9 15.45 9.45 15 10 15H15V10C15 9.45 15.45 9 16 9C16.55 9 17 9.45 17 10V15H22C22.55 15 23 15.45 23 16C23 16.55 22.55 17 22 17Z"
                fill="#F56620"
              />
            </svg>
          </Button>
          // </Link>
        )}
        {menuArr.assign_user && (
          <Button
            onClick={handleAssignUserModal}
            title="Assign User"
            style={{ padding: "5px", background: "0", border: "0" }}
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="16" cy="16" r="15.5" fill="white" stroke="#F56620" />
              <g clip-path="url(#clip0_736_1264)">
                <path
                  d="M22.3004 13.9996V14.4996H22.8004H23.6004C23.68 14.4996 23.7563 14.5312 23.8125 14.5875C23.8688 14.6437 23.9004 14.72 23.9004 14.7996C23.9004 14.8792 23.8688 14.9555 23.8125 15.0117C23.7563 15.068 23.68 15.0996 23.6004 15.0996H22.8004H22.3004V15.5996V16.3996C22.3004 16.4792 22.2688 16.5555 22.2125 16.6117C22.1563 16.668 22.08 16.6996 22.0004 16.6996C21.9208 16.6996 21.8445 16.668 21.7883 16.6117C21.732 16.5555 21.7004 16.4792 21.7004 16.3996V15.5996V15.0996H21.2004H20.4004C20.3208 15.0996 20.2445 15.068 20.1883 15.0117C20.132 14.9555 20.1004 14.8792 20.1004 14.7996C20.1004 14.72 20.132 14.6437 20.1883 14.5875C20.2445 14.5312 20.3208 14.4996 20.4004 14.4996H21.2004H21.7004V13.9996V13.1996C21.7004 13.12 21.732 13.0437 21.7883 12.9875C21.8445 12.9312 21.9208 12.8996 22.0004 12.8996C22.08 12.8996 22.1563 12.9312 22.2125 12.9875C22.2688 13.0437 22.3004 13.12 22.3004 13.1996V13.9996ZM18.8004 17.6996C19.7286 17.6996 20.6189 18.0684 21.2753 18.7247C21.9316 19.3811 22.3004 20.2714 22.3004 21.1996V22.7996C22.3004 22.8792 22.2688 22.9555 22.2125 23.0117C22.1563 23.068 22.08 23.0996 22.0004 23.0996C21.9208 23.0996 21.8445 23.068 21.7883 23.0117C21.732 22.9555 21.7004 22.8792 21.7004 22.7996V21.1996C21.7004 20.4305 21.3949 19.6929 20.851 19.149C20.3071 18.6051 19.5695 18.2996 18.8004 18.2996H12.4004C11.6313 18.2996 10.8936 18.6051 10.3498 19.149C9.80593 19.6929 9.50039 20.4305 9.50039 21.1996V22.7996C9.50039 22.8792 9.46878 22.9555 9.41252 23.0117C9.35626 23.068 9.27996 23.0996 9.20039 23.0996C9.12082 23.0996 9.04452 23.068 8.98826 23.0117C8.932 22.9555 8.90039 22.8792 8.90039 22.7996V21.1996C8.90039 20.2714 9.26914 19.3811 9.92552 18.7247C10.5819 18.0684 11.4721 17.6996 12.4004 17.6996H18.8004ZM15.6004 8.09961C16.5286 8.09961 17.4189 8.46836 18.0753 9.12474C18.7316 9.78111 19.1004 10.6714 19.1004 11.5996C19.1004 12.5279 18.7316 13.4181 18.0753 14.0745C17.4189 14.7309 16.5286 15.0996 15.6004 15.0996C14.6721 15.0996 13.7819 14.7309 13.1255 14.0745C12.4691 13.4181 12.1004 12.5279 12.1004 11.5996C12.1004 10.6714 12.4691 9.78111 13.1255 9.12474C13.7819 8.46836 14.6721 8.09961 15.6004 8.09961ZM15.6004 8.69961C15.2196 8.69961 14.8425 8.77462 14.4906 8.92036C14.1388 9.0661 13.8191 9.27971 13.5498 9.549C13.2805 9.81829 13.0669 10.138 12.9211 10.4898C12.7754 10.8417 12.7004 11.2188 12.7004 11.5996C12.7004 11.9804 12.7754 12.3575 12.9211 12.7094C13.0669 13.0612 13.2805 13.3809 13.5498 13.6502C13.8191 13.9195 14.1388 14.1331 14.4906 14.2789C14.8425 14.4246 15.2196 14.4996 15.6004 14.4996C16.3695 14.4996 17.1071 14.1941 17.651 13.6502C18.1949 13.1064 18.5004 12.3687 18.5004 11.5996C18.5004 10.8305 18.1949 10.0929 17.651 9.549C17.1071 9.00514 16.3695 8.69961 15.6004 8.69961Z"
                  stroke="#F56620"
                />
              </g>
              <defs>
                <clipPath id="clip0_736_1264">
                  <rect
                    width="19.2"
                    height="19.2"
                    fill="white"
                    transform="translate(6 6)"
                  />
                </clipPath>
              </defs>
            </svg>
          </Button>
        )}

        {menuArr.market_place && (
          <Link to="/market-place">
            <Button
              className={`icon-btn ${
                LOCATION.pathname == "/market-place" ? `menu-list-active` : ``
              }`}
              title="Market place "
            >
              <ShoppingCart className="icon-style" />
            </Button>
          </Link>
        )}
        {menuArr.info && <InfoComponent tooltipText={menuArr.infoText} />}
      </div>
      {modelStatus ? (
        <AssignUser
          showModal={modelStatus}
          closeModal={handleAssignUserModal}
        />
      ) : null}

      {!!formModal && <FormModal handleClose={_handleFormModal} />}
    </div>
  );
};

MenuList.defaultProps = {
  menuArr: {},
};

export default MenuList;
